import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useTypedSelector } from '../../../../../hooks';
import { getBasePrice } from '../../../ducks';
import { TermsBlock } from './TermsBlock';
import { TermsPrice } from './TermsPrice';

export const TermsBlockBasePrice = (): JSX.Element => {
  const basePrice = useTypedSelector(getBasePrice);
  return (
    <div className={'pt-[1em]'}>
      <TermsBlock
        title={
          <div className="text-primary">
            <Translate id={'request_flow.terms.block_heading.starting_price'} />
          </div>
        }
        type="blue-pale"
      >
        <div className="flex justify-between">
          <Translate id={'request_flow.terms.block_heading.starting_price_explain'} />
          <TermsPrice price={basePrice} addPlusMinusIndicator={false} />
        </div>
      </TermsBlock>
    </div>
  );
};
